import AuthWrapperOne from "@/app/shared/auth-layout/auth-wrapper-one";
import UnderlineShape from "@/components/shape/underline";
import SignInForm from "./sign-in-form";

export default function SignIn() {
    return (
        <AuthWrapperOne
            title={
                <>
                    Welcome back! Please{" "}
                    <span className="relative inline-block">
                        Sign in to
                        <UnderlineShape className="absolute -bottom-2 start-0 h-2.5 w-24 text-blue md:w-28 xl:-bottom-1.5 xl:w-36" />
                    </span>{" "}
                    continue.
                </>
            }
            description="By login, you will gain access to exclusive content, special
                        offers, and be the first to hear about exciting news and updates."
            bannerTitle="The simplest way to manage the company."
            bannerDescription="Amet minim mollit non deserunt ullamco est sit aliqua dolor do
                amet sint velit officia consequat duis."
            pageImage={
                <div className="relative mx-auto aspect-[4/3.37] w-[500px] xl:w-[620px] 2xl:w-[820px]">
                    <img
                        src={
                            "https://isomorphic-furyroad.s3.amazonaws.com/public/auth/sign-up.webp"
                        }
                        alt="Sign Up Thumbnail"
                        sizes="(max-width: 768px) 100vw"
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                </div>
            }
        >
            <SignInForm />
        </AuthWrapperOne>
    );
}
